import(/* webpackMode: "eager" */ "/vercel/path0/gondola-web-app/app/(app)/(invitesAndReferrals)/InvitePage.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/gondola-web-app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/gondola-web-app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
